import { Injectable, Injector } from '@angular/core';
import {config} from '@app/cuss/embross/utils/config';
import { getDataOperation, xml2json, getKeyByValue } from '@app/cuss/embross/utils/helper';
import { DeviceManager,DeviceStatus,deviceIds,TraceLevels, AppManager } from '../../embross-device-manager'
import OosManager from '@app/cuss/embross/devices/osManager';
import { Observable, Subject, BehaviorSubject } from "rxjs";
import {
  createScaleCallback,
  createSsbdCallback,
  CallbackContext,
} from '@app/cuss/embross/utils/callbacks/ssbd.callback';
import { createBagtagCallback } from '@app/cuss/embross/utils/callbacks/bagtag.callback';
import { SsbdEmergencyService } from '@app/services/ssbd-emergency.service';
import { BagtagMediaLowService } from '@app/services/bagtag-media-low.service';

let devMgr:any = new DeviceManager('127.0.0.1', 8800, false);
(window as any).devMgr = devMgr

let ossManager: OosManager;
@Injectable({
  providedIn: 'root'
})
export class CussService {
  //devMgr: DeviceManager = new DeviceManager('127.0.0.1', 8800, false);
  transferInfo = null;
  KioskID$ = new BehaviorSubject<string>(null);
  _KioskID = null;
  specialCountryCodeMapping = {
    "D": "DE"
  };

   oosMgr: any = {};
  errorsTypes = ['DECLINED', 'FAILURE', 'CANCEL'];
  statusOnDevices = new DeviceStatus();
  seatMap = null;
  // devMgr = new DeviceManager('127.0.0.1', 8800, false);

  // devMgr:any = (window as any).devMgr;
  $parsedbardCode: Subject<any> = new Subject<any>();

  /** Lazily-resolved emergency service to avoid circular DI. */
  private _ssbdEmergencyService: SsbdEmergencyService | null = null;
  /** Lazily-resolved Bag Tag low-paper service to avoid circular DI (CI-22506). */
  private _bagtagMediaLowService: BagtagMediaLowService | null = null;
  private readonly injector: Injector;

  /** Shared context for device callbacks */
  private callbackCtx: CallbackContext = {
    getDeviceManager: () => devMgr,
    getOOSManager: () => ossManager,
    getSsbdEmergencyService: () => this.resolveSsbdEmergencyService(),
    getBagtagMediaLowService: () => this.resolveBagtagMediaLowService(),
  };

  /** The shared SSBD callback used when SbdService is not actively handling events. */
  private readonly sharedSsbdCallback = createSsbdCallback(this.callbackCtx);

  /**
   * Pure low-paper callback: handles ONLY 107 MEDIA_LOW / 0 OK and never throws.
   * Used on its own by the active print path (BagtagprinterDeviceService).
   */
  private readonly bagtagMediaLowCallback = createBagtagCallback(this.callbackCtx);

  /**
   * The shared BAGTAG_PRINTER callback used while the printer is idle/standby.
   * Single instance: registered once in addDevices and restored by
   * BagtagprinterDeviceService.disable().
   *
   * Composes the pure low-paper callback with a verbatim delegation to
   * `readerOnEvent`, invoked with the very same `this` the SDK used to pass it
   * (the Device itself). Any outcome of that legacy call — including an exception
   * that makes the SDK's `DeviceEvent` setter skip `devEventListeners` — is
   * therefore identical to the behaviour before CI-22506. Exceptions are
   * deliberately NOT caught here.
   */
  private readonly sharedBagtagCallback = this.createSharedBagtagCallback();

  constructor(injector: Injector) {
    this.injector = injector;
      devMgr.setAppManager(this.appMgrOnChange, this.appMgrOnActive, this.appMgrOnEvent);
    // add passport to device manager

      devMgr.addDevices(deviceIds.PASSPORT_READER, this.readerOnEvent, this.isDeviceRequired(deviceIds.PASSPORT_READER));

    // setup barcodeReader
      devMgr.addDevices(deviceIds.BARCODE_READER,this.readerOnEvent,this.isDeviceRequired(deviceIds.BARCODE_READER));
    // setup ATBPrinter

    devMgr.addDevices(deviceIds.ATB_PRINTER, this.readerOnEvent, this.isDeviceRequired(deviceIds.ATB_PRINTER));
    // // setup BagtagPrinter


    // BAGTAG_PRINTER — shared low-paper callback while idle (CI-22506).
    // Handles only 107 MEDIA_LOW / 0 OK; every other code keeps its prior
    // (no-op) outcome, so 301-309 behaviour is unchanged.
    devMgr.addDevices(
      deviceIds.BAGTAG_PRINTER,
      this.sharedBagtagCallback,
      this.isDeviceRequired(deviceIds.BAGTAG_PRINTER)
    );

    devMgr.addDevices(
      deviceIds.BAGGAGE_SCALE,
      this.readerOnEvent,
      this.isDeviceRequired(deviceIds.BAGGAGE_SCALE)
    );

    devMgr.addDevices(deviceIds.PAYMENT, this.readerOnEvent, this.isDeviceRequired(deviceIds.PAYMENT));

    // setup Conveyor/Belt (AEA_BAGDROP) — dedicated SSBD callback
    devMgr.addDevices(
      deviceIds.AEA_BAGDROP,
      this.sharedSsbdCallback,
      this.isDeviceRequired(deviceIds.AEA_BAGDROP)
    );

    devMgr.onConnected = this.OnConnected;
    devMgr.appManager.onSocketOpened = this.OnSocketOpened;
    devMgr.appManager.onActive = this.onActive;
    devMgr.setMaxTraceLevel(TraceLevels.LOG_EXT_TRACE); // should be overwritten later by value from ETS config

    ossManager = new OosManager(
      devMgr,
      config.platformConfig.checkDeviceInterval,
      config.platformConfig.checkDeviceIntervalActive,
      false
    );
    devMgr.connect();
  }
  connect() {
    // devMgr = new DeviceManager('127.0.0.1', 8800, false);
    // setup application manager
    // devMgr.setAppManager(this.appMgrOnChange, this.appMgrOnActive, this.appMgrOnEvent);
    // add passport to device manager

    //devMgr.addDevices(deviceIds.PASSPORT_READER, this.passportReaderOnEvent, this.isDeviceRequired(deviceIds.PASSPORT_READER));

    // setup barcodeReader
    //devMgr.addDevices(deviceIds.BARCODE_READER,()=>{},this.isDeviceRequired(deviceIds.BARCODE_READER));
    // setup ATBPrinter

    //devMgr.addDevices(deviceIds.ATB_PRINTER, () => {}, this.isDeviceRequired(deviceIds.ATB_PRINTER));
    // // setup BagtagPrinter


    // this.devMgr.addDevices(deviceIds.BAGTAG_PRINTER, () => {}, this.isDeviceRequired(deviceIds.BAGTAG_PRINTER));

    // this.devMgr.addDevices(deviceIds.BAGGAGE_SCALE, () => {}, this.isDeviceRequired(deviceIds.BAGGAGE_SCALE));

    // this.devMgr.addDevices(deviceIds.PAYMENT, () => {}, this.isDeviceRequired(deviceIds.PAYMENT));
    // setup cussAccessibility
    //this.devMgr.addDevices(deviceIds.CUSS_ACCESSIBILITY, accessibilityOnEvent, isDeviceRequired(deviceIds.CUSS_ACCESSIBILITY));
    //devMgr.onConnected = this.OnConnected;
    //devMgr.appManager.onSocketOpened = this.OnSocketOpened;
    // devMgr.appManager.onActive = this.onActive;
    // devMgr.setMaxTraceLevel(TraceLevels.LOG_EXT_TRACE); // should be overwritten later by value from ETS config
  }


  appMgrOnChange = (change) => {
    const { key, value } = change;
    if (key == "kioskId") {
      if (value ) {
        this.KioskID$.next(value);
        this.KioskID = value;
      }
    }
  }

  set KioskID(KioskId) {
    this._KioskID = KioskId;
  }

  get KioskID () {
    return this._KioskID
  }

  set NextKisoksId(kisokId) {
    this.KioskID$.next(kisokId);
    this.KioskID = kisokId;
  }

  getKioskInfo(): Observable<string> {
    return this.KioskID$.asObservable();
  }

  OnConnected() {

    if (devMgr) {
      try{
        // this.clouds.showClous()
        const connLog = devMgr.setLogger('appManager', true);
        console.info("[ONCONNECT]", connLog);

        if (connLog) {
          // default log file
          devMgr.sendLogMsg(TraceLevels.LOG_EXT_TRACE, 'DeviceManager opened');
          devMgr.sendLogMsg(TraceLevels.LOG_EXT_TRACE, '***** Application version: ' + this.getVersion());
          devMgr.sendLogMsg(TraceLevels.LOG_EXT_TRACE, '***** Application build date: ' + this.getBuildDate());
        } else {
        }
        // send version
        devMgr.appManager.sendVersion('100', true);
        /** config values from websupport.property **/
        devMgr.appManager.getConfig('KIOSK_TYPE');
        devMgr.appManager.getConfig('SMGR_STATION_IN_ID');
        ossManager.start();
      }
      catch(error) {
        console.error(error);

        throw error;
      }
    }
  }

  OnSocketOpened = (restarting) => {
    if(this.getDeviceManager()) {
      if (restarting) {
        devMgr.sendLogMsg(TraceLevels.LOG_EXT_TRACE, 'OnSocketOpened - restarting');
      } else {
        devMgr.sendLogMsg(TraceLevels.LOG_EXT_TRACE, 'OnSocketOpened');
      }
    }
  }

  isDeviceRequired(deviceId) {
    let deviceName = getKeyByValue(deviceIds, deviceId);
    let ret = config.requiredDevices.indexOf(deviceName) > -1;
    console.info('isDeviceRequired:: deviceName:' + deviceName + ', value:' + ret);
    return false//ret;
  }

  onActive(evt) {
    devMgr.sendLogMsg(TraceLevels.LOG_TRACE, 'deviceName - main evt: ' + evt.key + ' ' + evt.value);
    if (evt.value) {
      sessionStorage.setItem('appMgrOnActive', 'true');
    }
  }

  appMgrOnActive(){
    // appLog('appMgrOnActive() called ..., going to main screen');
    sessionStorage.setItem('appMgrOnActive', 'true');
  }

  appMgrOnEvent(event) {

    console.warn('appMgrOnEvent() is called from client: ' + event.key + ' ' + event.value);
    console.info('appMgrOnEvent() is called from client: ' + event.key + ', value ' + event.value);
    if (event.key === 'notificationText') {
      console.info(event.value);
      if (event.value.indexOf('TRANSFER_INFO') >= 0) {
        let params = event.value.split('=');

      }
    }
    if (event.key === 'getConfig') {
      console.info('received kiosk type:', event.value);
      let res = event.value.split(',');
      if (res.length === 2 && res[0] === 'KIOSK_TYPE') {
        config.kioskType = res[1];
      }
    }
  }

  onInService() {
    console.info('onInService() is called from client.');
  }

  onOutOfService(reason) {
    console.info('onOutOfService() is called. ' + JSON.stringify(reason));
    /* ReactDOM.render(
      <OutOfService store={store} history={history} locale={config.defaultLanguage} />,
      document.getElementById('root')
    ) */
  }

  isResponseInService(json) {
    devMgr.sendLogMsg(
      TraceLevels.LOG_EXT_TRACE,
      'HB isResponseInService: json.etsResponse.inService: ' + json.etsResponse.inService
    );
    if (!config.etsInfo) {
      config.etsInfo = json.etsResponse.serverDetail;
    }
    return json.etsResponse.inService;
  }

  getDeviceManager(): DeviceManager {
    return devMgr;
  }

  getOOSManager(): OosManager {
    return ossManager;
  }

  /**
   * Returns the shared SSBD callback that should be restored
   * when SbdService.disable() releases the device.
   */
  getSharedSsbdCallback(): (event: any) => void {
    return this.sharedSsbdCallback;
  }

  /**
   * Returns the shared BAGTAG_PRINTER callback that should be restored
   * when BagtagprinterDeviceService.disable() releases the device.
   */
  getSharedBagtagCallback(): (event: unknown) => void {
    return this.sharedBagtagCallback;
  }

  /**
   * Returns only the pure low-paper callback (107/0). The active print path uses
   * this one so the legacy delegation cannot short-circuit the print callback.
   */
  getBagtagMediaLowCallback(): (event: unknown) => void {
    return this.bagtagMediaLowCallback;
  }

  /** Builds the composed standby callback described on `sharedBagtagCallback`. */
  private createSharedBagtagCallback(): (event: unknown) => void {
    return (event: unknown): void => {
      this.bagtagMediaLowCallback(event);
      this.readerOnEvent.call(devMgr?.getDevice(deviceIds.BAGTAG_PRINTER), event);
    };
  }

  /** Lazy-resolve BagtagMediaLowService to break circular DI (CI-22506). */
  private resolveBagtagMediaLowService(): BagtagMediaLowService | null {
    if (!this._bagtagMediaLowService) {
      try {
        this._bagtagMediaLowService = this.injector.get(BagtagMediaLowService);
      } catch {
        return null;
      }
    }
    return this._bagtagMediaLowService;
  }

  /** Lazy-resolve SsbdEmergencyService to break circular DI. */
  private resolveSsbdEmergencyService(): SsbdEmergencyService | null {
    if (!this._ssbdEmergencyService) {
      try {
        this._ssbdEmergencyService = this.injector.get(SsbdEmergencyService);
      } catch {
        // Service not yet available (shouldn't happen in production)
        return null;
      }
    }
    return this._ssbdEmergencyService;
  }

  getAppManager(): AppManager {
    return devMgr.getAppManager();
  }

  /*global VERSION*/
  getVersion() {
    return devMgr.getVersion();
  }

  isConnect() {
    return this.getDeviceManager()?.isConnected();
  }

  /*global BUILD_DATE*/
  getBuildDate() {
    return '"' + this.getCurrentDateTimeString() + '"';
  }

  getCurrentDateTimeString() {
    let d = new Date();
    let year = d.getFullYear();
    let month = d.getMonth() + 1;
    let day = d.getDate();
    let hour = d.getHours();
    let min = d.getMinutes();
    let second = d.getSeconds();
    let fMonth = month < 10 ? '0' + month : month;
    let fDay = day < 10 ? '0' + day : day + ' ';
    let fHour = hour < 10 ? '0' + hour : hour;
    let fMin = min < 10 ? '0' + min : min;
    let fSec = second < 10 ? '0' + second : second;
    return year + '-' + fMonth + '-' + fDay + '  ' + fHour + ':' + fMin + ':' + fSec;
  }

  //#endregion Payment

//#region Payment
  Payment = () => {
    const paymentDevice = this.getDeviceManager().getDevice(deviceIds.PAYMENT);
    this.callbackPayment.bind(paymentDevice);

    return {
      enablePay: () => {
        paymentDevice.enable();
      },
      enable: (name, KioskID, PNR, amount) => {
        paymentDevice.OnDeviceEvent = this.callbackPayment;
        paymentDevice.enable();
        this.setAmount(name, KioskID, PNR, amount,paymentDevice);
      },
      setAmount: this.setAmount,
      startTransaction: () => {
        paymentDevice.startTransaction();
      },
      getTransactionResult: () => {
        paymentDevice.getTransactionResult();
      },
      getPaymentState: () => {
        paymentDevice.getPaymentState();
      },
      cancelTransaction: () => {
        paymentDevice.cancelTransaction();
      },
      clearTransactionData: () => {
        paymentDevice.clearTransactionData();
      },
      disable: () => {
        paymentDevice.OnDeviceEvent = null;
        paymentDevice.disable();
      },
      device: paymentDevice
    };
  };

  setAmount(name, KioskID, PNR, amount,paymentDevice) {
    const reference = this.getReference(name, KioskID, PNR);
    amount = 1;
    paymentDevice.set('OPCODE', reference);
    paymentDevice.set('AMOUNT', amount);
  }

  getReference(name, KioskID, PNR) {
    var nameLen = name.length;
    var nameOwner = name && name.length > 0 ? name.substring(0, nameLen > 10 ? 10 : nameLen).toUpperCase() : "";
    var today = new Date();
    var format = today.toISOString();
    var dateReference = format.replace(/[-:T]/g, "");
    var dateSplit = dateReference.split(".");
    const sanitzeKiosko = KioskID.replace(/[-\\/:]/g, '');
    const KioskLen = sanitzeKiosko.length;

    const KioskIDSub = sanitzeKiosko.substring(0, KioskLen > 10 ? 10 : KioskLen);
    return nameOwner + KioskIDSub + PNR + dateSplit[0];
  }

  readerOnEvent(event) {
    if (event.key === 'statusChange' && event.value[0] > 300 && event.value[0] < 310) {
      this.getDeviceManager().getAppManager().sendApplicationLog(100, 'CDS_APPLOG,' + event.value[0] + ',passport reader is disconnected')
      this.getOOSManager().completeTransaction(true)
    }
  }

  callbackPayment(event) {
    switch (event.key) {
      case 'stateChanged':
        switch (event.value) {
          // when device is offline
          case 'STATE_UNAVAILABLE':

            break;
          // when device is initially initializing
          case 'STATE_INITIALIZING':

            break;
          // when the device is expecting user interaction and waiting for the amount to be charged to the customer
          case 'STATE_WAITING':
            break;
          // when the amount has been set by the application
          case 'STATE_READY, STATE_WAITING':
            // callbackLogs = 'Event: startTransaction() is called'
            // this.startTransaction();
            break;
          case 'STATE_WAITING, STATE_PENDING':
            break;
          case 'STATE_PENDING, STATE_READY':
            break;
          // when the transaction has been started by the application and we are awaiting the result of the transaction from the device
          case 'STATE_PENDING':
            break;
          // when the transaction has been approved
          case 'STATE_SUCCESS':
          case 'STATE_FAILURE, STATE_PENDING':
          case 'STATE_FAILURE':
          case 'STATE_SUCCESS, STATE_PENDING':
            break;
          default:
        }
        break;
      case 'getTransactionResult':
        const xmlResponse = event.value;
        let response = {
          success: true,
          approved: null,
          message: null
        };
        const { SALE } = getDataOperation(xmlResponse);

        const xmlNode = new DOMParser().parseFromString(xmlResponse, 'text/xml');
        const dataRead = JSON.parse(xml2json(xmlNode));
        const { PaymentResponse } = dataRead;
        if (PaymentResponse && PaymentResponse.PaymentResult) {
          response.success = this.errorsTypes.indexOf(PaymentResponse.PaymentResult)  === -1;
        }

        if (response.success) {
          if (SALE) {
            SALE.TDATE = SALE.TDATE.replace(/[/]/g, "-");
            SALE.THOUR = SALE.THOUR.replace(/[:]/g, "");
            SALE.dateOperation = `${SALE.TDATE} ${SALE.THOUR}`;
            response.approved = SALE;
          }
        }
        else {
          response.message = PaymentResponse.PaymentResult;
        }
        /*if (this.cussGlobal.getDataResult(event, response.success, response) !== undefined) {
          this.cussGlobal.getDataResult(event, response.success, response);
        }*/
        break;
      case 'keyPressed':
        break;
      case 'messageChanged':
        break;
      case 'statusChange':
        if (event.value[0] > 300 && event.value[0] < 310) {
          this.getOOSManager().completeTransaction(true);
        }
        break;
      default:
    }
  }

//#region Scale
  CarryOn = () => {
    const carryon = this.getDeviceManager().getDevice(deviceIds.CARRY_ON);
    return {
      enable: () => {
        carryon.enable();
      },
      disable: () => {
        carryon.disable();
      },
      device: carryon
    };
  };

}
